import React, { useState } from "react";
import { Modal, Button, ProgressBar, Form } from "react-bootstrap";

const steps = [
  {
    title: "Step 1: Notify Your Group",
    content: (
      <>
        <p className="font-weight-bold">
          Building your group's Support Team Member (employed members) Database
        </p>
        <p>
          Notify your group's membership that your group has partnered with
          JobInfoNetwork in an effort to support jobseekers within your group.
        </p>
        <p>
          Request that those members who are employed and who empathize with
          those who are struggling for employment, register themselves on
          JobInfoNetwork as a "Support Team Member".
        </p>
      </>
    ),
  },
  {
    title: "Step 2: Explain the Process",
    content: (
      <>
        <p>
          Share with your group that if a member of the group is seeking
          employment in the industry of the registered employed member, the job
          seeker may send a résumé and a request for any ideas, tips or
          contacts, the employed member might have.
        </p>
        <p>
          The job seeker will not be provided the employed member's contact
          information, unless the employed member adds it to the employed
          member's response.
        </p>
        <p>
          Responding to this request from a job seeker generally takes only a
          few minutes but can provide extremely valuable information to the job
          seeking member.
        </p>
      </>
    ),
  },
  {
    title: "Step 3: Repeat and Clarify",
    content: (
      <>
        <p>
          This notification to your group may need to be repeated several times
          given that this system may be unfamiliar to your group and require
          some repetition and clarification.
        </p>
        <p>
          Ensure that all participants understand that the purpose of this
          system is to benefit those who are less fortunate and simply need
          information which the employed members likely can provide. It is truly
          a compassionate effort. All participants should understand this and
          approach it with an attitude of kindness and empathy.
        </p>
      </>
    ),
  },
];

export default function SupportTeamOnboardingModal({ show, onHide, onFinish }) {
  const [step, setStep] = useState(0);

  const handleNext = () => {
    if (step < steps.length - 1) setStep(step + 1);
    else {
      if (onFinish) onFinish(true);
      onHide();
      setStep(0); // reset for next open
    }
  };

  const handleBack = () => {
    if (step > 0) setStep(step - 1);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{steps[step].title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProgressBar now={((step + 1) / steps.length) * 100} className="mb-3" />
        {steps[step].content}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleBack} disabled={step === 0}>
          Back
        </Button>
        <Button variant="primary" onClick={handleNext}>
          {step === steps.length - 1 ? "Finish" : "Next"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
